<template>
  <div>
    <div class="dataText">
      <p>Living under an armed occupation, the everyday lives of civilians in Kashmir has been full of different fears. The fear of being stopped at a checkpoint to show your identification in case you forgot your wallet. The fear of detention during crackdowns. The fear of getting caught up in an encounter or between stone-pelters. The fear of harassment from a patrolling unit moving through your village. A recent report by Medecins Sans Frontieres (Doctors without borders) concluded at least 93% of Kashmiris have experienced conflict-related trauma, with about 11% of the entire populations suffering from depression and 6% from PTSD.</p>
      <br>
      <p>Tchær is an attempt to shed some light on the conflict in the hard-everyday lives of the people of Kashmir. Clicking on the below link will open up a new tab with the game.</p>
      <v-btn @click="tchaerLinkOpen()">Tchær</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tchaerLink: "https://frsqz.itch.io/tchr"
    };
  },
  methods: {
    tchaerLinkOpen() {
      window.open(this.tchaerLink, "_blank");
    }
  }
};
</script>

<style lang="stylus" scoped>
.dataText {
  margin: 5rem 2rem;
  font-size: 1.5rem;
  font-family: 'Raleway', sans-serif;
}

@media only screen and (max-width: 600px) {
  .dataText {
    margin: 5rem 2rem 0 2rem;
    font-size: 1.2rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .dataText {
    margin: 5rem 3rem;
    font-size: 1.3rem;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .dataText {
    margin: 6rem 4rem;
    font-size: 1.3rem;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .dataText {
    margin: 7rem 7rem 0rem 7rem;
    font-size: 1.4rem;
    
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1270px) {
  .dataText {
    margin: 2rem 15rem 0 15rem;
    font-size: 1.3rem;
    // transform translateY(-2rem)
  }
}
@media only screen and (min-width: 1300px) {
  .dataText {
    margin: 4rem 15rem 0 15rem;
    font-size: 1.3rem;
    // transform translateY(-2rem)
  }
}
@media only screen and (min-width: 1600px) {
  .dataText {
    margin: 0rem 15rem 0 15rem;
    font-size: 1.3rem;
    transform translateY(-1.6rem)
  }
}
</style>
